module.exports = __webpack_public_path__ + "img/20180815_152858_222.4851bf64.jpg";